// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import Close from "@rpsc/XDL/Icons/IconClose";
import { buttonTransparent } from "@rpsc/XDL/PreStyle/button";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xBaseTheme } from "@rpsc/XDL/types";
import color, { getSystemColor } from "@rpsc/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            color: "common.white",
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 17px;
                max-width: 100%;
            `,
        },
        color: "primary",
        iconProps: {
            size: 7,
            src: Close,
        },
        css: css`
            min-height: 25px;
            border-radius: 13px;
            align-items: center;
            max-width: 100%;
            word-break: break-all;
            gap: 8px;
            padding: 4px 8px;
            margin: 0 8px 8px 0;
            button {
                margin: 0;
                ${buttonTransparent}

                & ${IconWrapper},  & svg {
                    color: ${color("common.ui1")};
                    width: 7px;
                    height: 7px;
                }
                &:focus:not(:disabled),
                &:hover:not(:disabled) {
                    ${IconWrapper}, svg {
                        color: ${color("common.border")};
                    }
                }
            }
        `,
    },
} as xBaseTheme["tag"];
